import { stringRequired } from '../../utils/validations';
import { ChecklistTriggerType } from '../types';

export function useCheckListTrigger() {
	return {
		validate: (values: ChecklistTriggerType): {
      hasError: () => boolean;
      errors: {
        field: string | null;
      }
    } => {
			let hasErrors = false;
			const validations = {
				field: [
					stringRequired(values.field, 'This field is required')
				],
			};

			const getError = (validation: Array<string | undefined>) => {
				const foundError = validation.find(item => item !== undefined) || null;
				if (foundError) {
					hasErrors = true;
				}
        
				return foundError || null;
			};

			return {
				hasError: () => hasErrors,
				errors: {
					field: getError(validations.field),
				}
			};
		},
		getValues: (data: ChecklistTriggerType): { field: string } => {
			return {
				field: data.field,
			};
		}
	};
}